import { ProductDataAllergenStatus } from '@libs/shop/models';

export const NUTRITION_INFO_LABELS: Readonly<Record<string, string>> = {
  energy_kj: 'Energie (kj)',
  energy_kcal: 'Energie (kcal)',
  transfat_acids: 'Transfettsäuren',
  bread_unit: 'Broteinheiten',
  salt: 'Salz',
  fat: 'Fett',
  fat_saturated: 'gesättigte Fettsäuren',
  fat_mono_unsaturated: 'einfach ungesättigte Fettsäuren',
  fat_poly_unsaturated: 'mehrfach ungesättigte Fettsäuren',
  carbohydrates: 'Kohlenhydrate',
  carbohydrates_sugar: 'Zucker',
  roughage: 'Ballaststoffe',
  protein: 'Eiweiß',
  sodium: 'Natrium',
};

export const MEASURES_LABELS: Readonly<Record<string, string>> = {
  single_unit: 'Verkaufseinheit',
  package: 'Paket',
  end_user_unit: 'Endverbrauchereinheit',
};

export const ALLERGEN_LABELS: Readonly<Record<string, string>> = {
  grain: 'Glutenhaltiges Getreide',
  crustaceans: 'Krebstiere',
  eggs: 'Eier',
  fish: 'Fisch',
  peanuts: 'Erdnüsse',
  soy: 'Soja',
  milk: 'Milch',
  peelFruit: 'Schalenfrüchte',
  celery: 'Sellerie',
  mustard: 'Senf',
  sesame: 'Sesam',
  sulfurDioxide: 'Schwefeldioxid und Sulphite',
  lupine: 'Lupinen',
  molluscs: 'Weichtiere',
  spelt: 'Dinkel',
  barley: 'Gerste',
  oats: 'Hafer',
  hazelnut: 'Haselnuss',
  kamut: 'Kamut',
  cashew: 'Kaschunuss',
  macadamia: 'Macadamia',
  almond: 'Mandeln',
  brazilNut: 'Paranuss',
  pecan: 'Pecannuss',
  pistachio: 'Pistazie',
  rye: 'Roggen',
  walnut: 'Walnuss',
  wheat: 'Weizen',
  other: 'Sonstige',
};

export const ALLERGEN_STATUS_LABELS: Readonly<Record<ProductDataAllergenStatus, string>> = {
  contains: 'Enthält',
  mayContain: 'Kann Spuren enthalten von',
};
